import React from 'react'
import { styled } from '../../lib/stitches'
import { gray15, gray3 } from '../platform/color'
import ClickToCopy from './ClickToCopy'
import { Spacer, Text } from './Components'
import { CopyClipboard } from './icons'

const StyledCopyButton = styled('button', {
  backgroundColor: gray3,
  color: gray15,
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  borderRadius: '6px',
  border: 'none',
  padding: '9px 12px'
})

const TruncatedText = styled(Text, {
  marginBottom: 0,
  fontWeight: 500,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  marginRight: '24px'
})

interface Props {
  link: string
}

const CopyTextButton: React.FC<Props> = ({ link }) => (
  <ClickToCopy copyContent={link}>
    <StyledCopyButton>
      <TruncatedText>{link}</TruncatedText>
      <Spacer />
      <CopyClipboard style={{ width: '16px', height: '16px' }} />
    </StyledCopyButton>
  </ClickToCopy>
)

export default CopyTextButton
